"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AndOptions = void 0;
const vue_1 = require("vue");
const PlayerInputFactory_1 = require("./PlayerInputFactory");
const Button_1 = require("../components/common/Button");
const i18n_1 = require("../directives/i18n");
exports.AndOptions = vue_1.default.component('and-options', {
    props: {
        player: {
            type: Object,
        },
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {};
    },
    methods: {
        saveData: function () {
            for (let i = 0; i < this.$data.childComponents.length; i++) {
                const componentInstance = this.$data.childComponents[i]
                    .componentInstance;
                if (componentInstance !== undefined) {
                    if (componentInstance.saveData instanceof Function) {
                        componentInstance.saveData();
                    }
                }
            }
            const res = [];
            if (this.playerinput.options !== undefined) {
                for (let i = 0; i < this.playerinput.options.length; i++) {
                    res.push(this.$data.responded['' + i]);
                }
            }
            this.onsave(res);
        },
    },
    render: function (createElement) {
        const playerInput = this.playerinput;
        const children = [];
        this.$data.childComponents = [];
        this.$data.responded = [];
        if (this.showtitle) {
            children.push(createElement('div', { 'class': 'wf-title' }, i18n_1.$t(playerInput.title)));
        }
        if (playerInput.options !== undefined) {
            const options = playerInput.options;
            options.forEach((option, idx) => {
                if (this.$data.responded[idx] === undefined) {
                    children.push(new PlayerInputFactory_1.PlayerInputFactory().getPlayerInput(createElement, this.players, this.player, option, (out) => {
                        this.$data.responded[idx] = out[0];
                    }, false, true));
                    this.$data.childComponents.push(children[children.length - 1]);
                }
            });
        }
        if (this.showsave) {
            const saveBtn = createElement(Button_1.Button, {
                props: {
                    title: playerInput.buttonLabel,
                    type: 'submit',
                    size: 'normal',
                    onClick: () => {
                        this.saveData();
                    },
                },
            });
            children.push(createElement('div', { 'class': 'wf-action' }, [saveBtn]));
        }
        return createElement('div', { 'class': 'wf-options' }, children);
    },
});
//# sourceMappingURL=AndOptions.js.map